import * as uuid from 'uuid';

import { type Conflict, type ReorderConflict, ConflictType } from '@editor2/types/conflict';

export const getModifiedDeletedConflict = ({ attribute, id, state, entityType, entityId }) => {
	const initial = state.initialCourse[attribute].entities[id];
	const current = state[attribute].entities[id];

	const conflict: Conflict = {
		conflictId: uuid.v4(),
		conflictType: ConflictType.ModifiedDeleted,
		entityType,
		entityId,
		attribute: attribute,
		initial,
		current,
		incoming: undefined
	};
	return conflict;
};

export const getDeletedModifiedConflict = ({ attribute, id, state, incoming, entityType }) => {
	const initial = state.initialCourse[attribute].entities[id];

	const conflict: Conflict = {
		conflictId: uuid.v4(),
		conflictType: ConflictType.DeletedModified,
		entityType,
		entityId: initial.family_id,
		attribute: attribute,
		initial,
		current: undefined,
		incoming
	};
	return conflict;
};

export const getItemMoveConflict = ({
	initial,
	current,
	incoming,
	attribute,
	entityId,
	entityType
}) => {
	const conflict: Conflict = {
		conflictId: uuid.v4(),
		conflictType: ConflictType.ItemMove,
		initial,
		current,
		incoming,
		attribute,
		entityType,
		entityId
	};

	return conflict;
};

export const getReorderConflict = ({ initial, current, incoming, attribute }) => {
	const conflict: ReorderConflict = {
		conflictId: uuid.v4(),
		conflictType: ConflictType.ChildrenReorder,
		entityType: initial.type || current.type || incoming.type,
		entityId: incoming.family_id,
		attribute: attribute,
		initial: initial && initial[attribute],
		current: current && current[attribute],
		incoming: incoming && incoming[attribute]
	};
	return conflict;
};

export const getPropertyConflict = ({ initial, current, incoming, attribute }) => {
	const conflict: Conflict = {
		conflictId: uuid.v4(),
		conflictType: ConflictType.Property,
		entityType: initial.type || current.type || incoming.type,
		entityId: incoming.family_id,
		attribute: attribute,
		initial: initial[attribute],
		current: current[attribute],
		incoming: incoming[attribute]
	};
	return conflict;
};
